import validator from 'validator';

export default (email: string) => {
  if (validator.isEmail(email)) return undefined;
  return 'Invalid email.';
};
